
import React from 'react';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../css/toast.css";
import { Outlet } from 'react-router-dom';
import Header from './header';
import Footer from './footer';


function MainTemplate() {
  return (
    <div className="d-flex flex-column min-vh-100">
      <Header />
      <main className="flex-grow-1 container py-4">
         <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default MainTemplate;

